var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimer = function SvgTimer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1H9.5V3H15.5V1ZM11.5 14H13.5V8H11.5V14ZM19.53 7.39L20.95 5.97C20.52 5.46 20.05 4.98 19.54 4.56L18.12 5.98C16.57 4.74 14.62 4 12.5 4C7.53 4 3.5 8.03 3.5 13C3.5 17.97 7.52 22 12.5 22C17.48 22 21.5 17.97 21.5 13C21.5 10.88 20.76 8.93 19.53 7.39ZM12.5 20C8.63 20 5.5 16.87 5.5 13C5.5 9.13 8.63 6 12.5 6C16.37 6 19.5 9.13 19.5 13C19.5 16.87 16.37 20 12.5 20Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimer);
export { ForwardRef as ReactComponent };